var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalender(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5049_1097",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5049_1097)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.0833 15C11.5 15 11.0069 14.7986 10.6042 14.3959C10.2014 13.9931 10 13.5 10 12.9167C10 12.3334 10.2014 11.8403 10.6042 11.4375C11.0069 11.0347 11.5 10.8334 12.0833 10.8334C12.6667 10.8334 13.1597 11.0347 13.5625 11.4375C13.9653 11.8403 14.1667 12.3334 14.1667 12.9167C14.1667 13.5 13.9653 13.9931 13.5625 14.3959C13.1597 14.7986 12.6667 15 12.0833 15ZM4.16667 18.3334C3.70833 18.3334 3.31597 18.1702 2.98958 17.8438C2.66319 17.5174 2.5 17.125 2.5 16.6667V5.00002C2.5 4.54169 2.66319 4.14933 2.98958 3.82294C3.31597 3.49655 3.70833 3.33335 4.16667 3.33335H5V1.66669H6.66667V3.33335H13.3333V1.66669H15V3.33335H15.8333C16.2917 3.33335 16.684 3.49655 17.0104 3.82294C17.3368 4.14933 17.5 4.54169 17.5 5.00002V16.6667C17.5 17.125 17.3368 17.5174 17.0104 17.8438C16.684 18.1702 16.2917 18.3334 15.8333 18.3334H4.16667ZM4.16667 16.6667H15.8333V8.33335H4.16667V16.6667Z",
    fill: "#47484C"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalender);
export default __webpack_public_path__ + "static/media/calender.6afd1675b86a1680b0a6678c1e802ab9.svg";
export { ForwardRef as ReactComponent };